/*eslint-disable */

import { Agenda, Day, Month, SchedulePlugin, Week, WorkWeek } from '@syncfusion/ej2-vue-schedule';

import Vue from "vue";
import {
  mapGetters
} from 'vuex';

Vue.use(SchedulePlugin);
export default {
  name: 'scheduler-data',
  components: {
  },
  props: [],
  data () {
    return {
      selectedDate: new Date(),
      readonly: false,
      eventSettings: { 
        dataSource: this.generateData(),
      },
      currentView: 'Month',
      enableAdaptiveUI:false,
      currentUserId:''
    }
  },
  provide: {
    schedule: [Month]
  },
  computed: {
    ...mapGetters([
      'getSchedulerListGetter'
    ]),
  },
  mounted () {
    this.currentUserId = localStorage.getItem('LoginedUserID');
  },
  methods: {   
    onEventRendered(args){
      if(args.data.Description =='Appointment Scheduled'){
        (args.element).style.backgroundColor = '#F57F17';
      }else if(args.data.Subject == 'Demo Request'){
        (args.element).style.backgroundColor = '#b41818';
      }else if(args.data.Subject == 'Lymphomap Meeting'){
        (args.element).style.backgroundColor = '#ff0b00';
      }
    },
    generateData() {
        var collections = [];
        var dataCollections =  [this.$store.getters.getSchedulerListGetter];
        for (var i = 0; i < dataCollections.length; i++) {
            collections = collections.concat(dataCollections[i]);
        }
        return collections;
    },
    onActionComplete(event){
      if(event.requestType == 'eventCreated'){
        var CreateEventId = this.currentUserId + event.data[0].Id
         let data = {
           Subject : event.data[0].Subject,
           StartTime:event.data[0].StartTime,
           EndTime:event.data[0].EndTime,
           Id:CreateEventId,
           Description:event.data[0].Description,
           StartTimezone:event.data[0].StartTimezone,
           EndTimezone:event.data[0].EndTimezone
         }
         this.$store.dispatch('createSchedulerDetailsAction', data).then((res) => {
           this.getSchedulerListAgain()
         })
      }else if(event.requestType == 'eventRemoved'){
          if(event.deletedRecords[0].user){
            var RemoveEvtId = event.deletedRecords[0].Id
            this.$store.dispatch('removeSchedulerDetailsAction', {id:RemoveEvtId}).then((res) => {
             this.getSchedulerListAgain()
            })
          }else{
            var RemoveEvtId = this.currentUserId + event.deletedRecords[0].Id
            this.$store.dispatch('removeSchedulerDetailsAction', {id:RemoveEvtId}).then((res) => {
             this.getSchedulerListAgain()
            })
          }
      }else if(event.requestType == 'eventChanged'){
        let udata = {
          Subject : event.data[0].Subject,
          StartTime:event.data[0].StartTime,
          EndTime:event.data[0].EndTime,
          Description:event.data[0].Description,
          StartTimezone:event.data[0].StartTimezone,
          EndTimezone:event.data[0].EndTimezone
        }
        if(event.data[0].user){
         var UpdateEventId = event.data[0].Id
        }else{
          var UpdateEventId = this.currentUserId + event.data[0].Id
        }
        this.$store.dispatch('updateSchedulerDetailsAction', {data:{data:udata, id:UpdateEventId}}).then((res) => {
          this.getSchedulerListAgain()
        })
      }
    },
    getSchedulerListAgain(){
      this.$store.dispatch('getSchedulerListAction')
    },
  }
}